<mat-card>
  <div class="privacy-main-container">
    <div class="header">
      <img priority="5" ngSrc="{{ image }}" height="128" width="239" alt="elitment image" />
    </div>
    
    <div class="privacy-container privacy-en">
      <div class="privacy-title" (click)="onTitleClicked('EN')">
        {{ privacyTitleEn }}
        <mat-icon class="privacy-icon">{{ isPrivacyEnOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
      </div>
      <div class="privacy" [ngClass]="isPrivacyEnOpened ? 'privacy-opened' : 'privacy-closed'" >
        <p><i>This is an unofficial English translation. Only the original French version is legally binding and authoritative.</i></p>
    
        <b>1. Data Collected</b>
        <br>
        <span>
          We collect the following data when you use our application:
          <ul>
            <li>Personal data: First name, last name, email, profession (if applicable).</li>
            <li>Training-related data: Programs, assessments, and other information voluntarily entered into the app.</li>
            <li>Technical data: IP address, device type, operating system, and activity logs.</li>
          </ul>
        </span>
        
        <b>2. Use of Data</b>
        <br>
        <span>
          Your data is used to:
          <ul>
            <li>Provide and improve the services of Elitment Performance.</li>
            <li>Assist you in managing your training sessions.</li>
            <li>Respond to your support requests.</li>
          </ul>
          We will never use your data for commercial purposes without your explicit consent.
        </span>
        <br><br>
        <b>3. Data Sharing</b>
        <br>
        <span>
          We only share your data with:
          <ul>
            <li>Our technical providers to ensure the proper functioning of the application.</li>
            <li>Competent authorities in case of legal obligations.</li>
          </ul>
        </span>
        <b>4. Storage and Security</b>
        <br>
        <span>
          Your data is stored on secure servers located in Switzerland or in third countries that comply with applicable regulations (such as the GDPR for the EU). We use advanced security measures to protect your information from unauthorized access.
        </span>
        <br><br>
        <b>5. Your Rights</b>
        <br>
        <span>
          You have the following rights regarding your data:
          <ul>
            <li>Access, rectification, and deletion.</li>
            <li>Objection to or restriction of the processing of your data.</li>
            <li>Data portability to another provider.</li>
          </ul>
          To exercise these rights, contact us at <a href="mailto:info@elitment.com">info&#64;elitment.com</a>.
        </span>
        <br><br>
        <b>6. Data Retention</b>
        <br>
        <span>
          Your data is retained for as long as necessary to provide our services. You may request its deletion at any time.
        </span>
        <br><br>
        <b>7. Cookies</b>
        <br>
        <span>
          We use cookies to ensure the proper functioning of the application and to enhance your user experience. You can manage your preferences through your browser settings.
        </span>
        <br><br>
        <b>8. Changes</b>
        <br>
        <span>
          We may update this policy at any time. Users will be notified of major changes before they take effect.
        </span>
        <br><br>
        <b>9. Contact</b>
        <br>
        <span>
          For any questions regarding this policy, contact us:
          <br><br>
          Email: <a href="mailto:info@elitment.com">info&#64;elitment.com</a><br>
          Address: ELITMENT SA, Rue de l'industrie 13, 1950 Sion.
          <br><br>
          By using the application, you agree to this privacy policy.
        </span>
      </div>
    </div>
    <div class="separator"></div>
    <div class="privacy-container privacy-fr">
      <div class="privacy-title" (click)="onTitleClicked('FR')">
        {{ privacyTitleFr }}
        <mat-icon class="privacy-icon">{{ isPrivacyFrOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
      </div>
      <div class="privacy" [ngClass]="isPrivacyFrOpened ? 'privacy-opened' : 'privacy-closed'" >
        <b>1. Données collectées</b>
        <br>
        <span>
          Nous collectons les données suivantes lors de l'utilisation de notre application :
          <ul>
            <li>Données personnelles : Nom, prénom, email, profession (le cas échéant).</li>
            <li>Données liées à l'entraînement : Programmes, évaluations et autres informations saisies volontairement dans l'application.</li>
            <li>Données techniques : Adresse IP, type d'appareil, système d'exploitation, et journaux d'activités.</li>
          </ul>
        </span>
        
        <b>2. Utilisation des données</b>
        <br>
        <span>
          Vos données sont utilisées pour :
          <ul>
            <li>Fournir et améliorer les services de Elitment Performance.</li>
            <li>Vous assister dans la gestion de vos entraînements.</li>
            <li>Répondre à vos demandes de support.</li>
          </ul>
          Nous n'utiliserons jamais vos données à des fins commerciales sans votre consentement explicite.
        </span>
        <br><br>
        <b>3. Partage des données</b>
        <br>
        <span>
          Nous ne partageons vos données qu'avec :
          <ul>
            <li>Nos prestataires techniques pour assurer le bon fonctionnement de l'application.</li>
            <li>Les autorités compétentes en cas d'obligation légale.</li>
          </ul>
        </span>        
        <b>4. Stockage et sécurité</b>
        <br>
        <span>
          Vos données sont stockées sur des serveurs sécurisés situés en Suisse ou dans des pays tiers respectant les réglementations applicables (comme le RGPD pour l'UE). Nous utilisons des mesures de sécurité avancées pour protéger vos informations contre les accès non autorisés.
        </span>
        <br><br>
        <b>5. Vos droits</b>
        <br>
        <span>
          Vous disposez des droits suivants sur vos données :
          <ul>
            <li>Accès, rectification et suppression.</li>
            <li>Opposition ou limitation du traitement de vos données.</li>
            <li>Portabilité de vos données vers un autre prestataire.</li>
          </ul>
          Pour exercer ces droits, contactez-nous à <a href="mailto:info@elitment.com">info&#64;elitment.com</a>.
        </span>
        <br><br>
        <b>6. Durée de conservation</b>
        <br>
        <span>
          Vos données sont conservées aussi longtemps que nécessaire pour fournir nos services. Vous pouvez demander leur suppression à tout moment.
        </span>
        <br><br>
        <b>7. Cookies</b>
        <br>
        <span>
          Nous utilisons des cookies pour assurer le bon fonctionnement de l'application et améliorer votre expérience utilisateur. Vous pouvez gérer vos préférences via les paramètres de votre navigateur.
        </span>
        <br><br>
        <b>8. Modifications</b>
        <br>
        <span>
          Nous pouvons modifier cette politique à tout moment. Les utilisateurs seront notifiés des changements majeurs avant leur entrée en vigueur.
        </span>
        <br><br>
        <b>9. Contact</b>
        <br>
        <span>
          Pour toute question concernant cette politique, contactez-nous :
          <br><br>
          Email : <a href="mailto:info@elitment.com">info&#64;elitment.com</a><br>
          Adresse : ELITMENT SA, Rue de l'industrie 13, 1950 Sion.
          <br><br>
          En utilisant l'application, vous acceptez cette politique de confidentialité.
        </span>
      </div>
    </div>
    <div class="separator"></div>
    <div class="privacy-container privacy-it">
      <div class="privacy-title" (click)="onTitleClicked('IT')">
        {{ privacyTitleIt }}
        <mat-icon class="privacy-icon">{{ isPrivacyItOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
      </div>
      <div class="privacy" [ngClass]="isPrivacyItOpened ? 'privacy-opened' : 'privacy-closed'" >
        <p><i>Questa è una traduzione non ufficiale in italiano. Solo la versione originale in francese ha valore legale e fa fede ufficialmente.</i></p>
    
        <b>1. Dati raccolti</b>
        <br>
        <span>
          Raccogliamo i seguenti dati durante l'utilizzo della nostra applicazione:
          <ul>
            <li>Dati personali: Nome, cognome, email, professione (se del caso).</li>
            <li>Dati relativi all'allenamento: Programmi, valutazioni e altre informazioni inserite volontariamente nell'applicazione.</li>
            <li>Dati tecnici: Indirizzo IP, tipo di dispositivo, sistema operativo e registri delle attività.</li>
          </ul>
        </span>
        
        <b>2. Utilizzo dei dati</b>
        <br>
        <span>
          I tuoi dati vengono utilizzati per:
          <ul>
            <li>Fornire e migliorare i servizi di Elitment Performance.</li>
            <li>Assisterti nella gestione dei tuoi allenamenti.</li>
            <li>Rispondere alle tue richieste di supporto.</li>
          </ul>
          Non utilizzeremo mai i tuoi dati per scopi commerciali senza il tuo esplicito consenso.
        </span>
        <br><br>
        <b>3. Condivisione dei dati</b>
        <br>
        <span>
          Condividiamo i tuoi dati solo con:
          <ul>
            <li>I nostri fornitori tecnici per garantire il corretto funzionamento dell'applicazione.</li>
            <li>Le autorità competenti in caso di obbligo legale.</li>
          </ul>
        </span>
        <b>4. Conservazione e sicurezza</b>
        <br>
        <span>
          I tuoi dati sono conservati su server sicuri situati in Svizzera o in paesi terzi che rispettano le normative applicabili (come il GDPR per l'UE). Usiamo misure di sicurezza avanzate per proteggere le tue informazioni da accessi non autorizzati.
        </span>
        <br><br>
        <b>5. I tuoi diritti</b>
        <br>
        <span>
          Hai i seguenti diritti sui tuoi dati:
          <ul>
            <li>Accesso, rettifica e cancellazione.</li>
            <li>Opposizione o limitazione del trattamento dei tuoi dati.</li>
            <li>Portabilità dei tuoi dati verso un altro fornitore.</li>
          </ul>
          Per esercitare questi diritti, contattaci a <a href="mailto:info@elitment.com">info&#64;elitment.com</a>.
        </span>
        <br><br>
        <b>6. Durata della conservazione</b>
        <br>
        <span>
          I tuoi dati sono conservati per tutto il tempo necessario a fornire i nostri servizi. Puoi richiederne la cancellazione in qualsiasi momento.
        </span>
        <br><br>
        <b>7. Cookie</b>
        <br>
        <span>
          Utilizziamo i cookie per garantire il corretto funzionamento dell'applicazione e migliorare la tua esperienza utente. Puoi gestire le tue preferenze tramite le impostazioni del tuo browser.
        </span>
        <br><br>
        <b>8. Modifiche</b>
        <br>
        <span>
          Possiamo modificare questa politica in qualsiasi momento. Gli utenti saranno informati delle modifiche importanti prima che entrino in vigore.
        </span>
        <br><br>
        <b>9. Contatto</b>
        <br>
        <span>
          Per qualsiasi domanda relativa a questa politica, contattaci:
          <br><br>
          Email: <a href="mailto:info@elitment.com">info&#64;elitment.com</a><br>
          Indirizzo: ELITMENT SA, Rue de l'industrie 13, 1950 Sion.
          <br><br>
          Utilizzando l'applicazione, accetti questa politica sulla privacy.
        </span>
      </div>
    </div>
  </div>
</mat-card>
